import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon79: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M4.5 0a.5.5 0 0 1 .5.5V1h2.7L9.374.149c.702-.247 1.186-.162 2.152.223L15 1.762V.5a.5.5 0 0 1 .41-.492L15.5 0h4a.5.5 0 0 1 .5.5v6.514A1.986 1.986 0 0 1 18.014 9H15.5a.5.5 0 0 1-.5-.5v-.877l-.087-.078-1.553 1.13a5.714 5.714 0 0 1-6.72 0L5 7.482V8.5a.5.5 0 0 1-.5.5H1.986A1.986 1.986 0 0 1 0 7.014V.5A.5.5 0 0 1 .5 0h4Zm1.842 2H5v4.245l2.228 1.62A4.715 4.715 0 0 0 12.579 8l.193-.133 1.38-1.005-3.94-3.543-.078.037-.086.042c-.376.18-.809.401-1.293.663-.996.538-2.058.498-2.545-.33-.34-.574-.278-1.187.132-1.73ZM4 1H1v6.014c0 .545.441.986.986.986H4V1Zm15 0h-3v7h2.014A.986.986 0 0 0 19 7.014V1Zm-9.232.066L7.724 2.109c-.684.402-.847.786-.653 1.113.15.255.626.273 1.208-.041.498-.27.945-.498 1.335-.685.236-.114.402-.19.491-.228a.5.5 0 0 1 .532.087L14.98 6.26l.02-.015V2.838l-3.845-1.537c-.757-.302-1.042-.352-1.387-.235Z"
      />
    </Svg>
  )
}
